import { useEffect, useState } from "react";

interface ImageUploadProps {
  image?: File;
  fileChanged: Function;
}

export const ImageUpload = (props: ImageUploadProps) => {
  const [selectedFile, setSelectedFile] = useState<File | undefined>(
    props.image,
  );
  const [preview, setPreview] = useState<string>();

  useEffect(() => {
    setSelectedFile(props.image);
  }, [props.image]);

  // create a preview as a side effect, whenever selected file is changed
  useEffect(() => {
    if (!selectedFile) {
      setPreview(undefined);
      return;
    }

    const objectUrl = URL.createObjectURL(selectedFile);
    setPreview(objectUrl);

    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile]);

  return (
    <>
      <div>
        <input
          type="file"
          onChange={(e) => {
            if (!e.target.files || e.target.files.length === 0) {
              setSelectedFile(undefined);
              props.fileChanged(undefined);
              return;
            }

            // I've kept this example simple by using the first image instead of multiple
            setSelectedFile(e.target.files[0]);
            props.fileChanged(e.target.files[0]);
          }}
        />
      </div>
      <div>
        {selectedFile && <img src={preview} style={{ maxWidth: "100%" }} />}
      </div>
    </>
  );
};
